<template>
  <div class="body">
    <div class="payment-error-container">
      <div class="payment-content">
        <div class="payment-error-title">
          <h3>{{ $t(`message.payment.paymentErrorTitle`) }}</h3>
        </div>
        <div class="payment-error-content">
          <p>
            {{ $t(`message.payment.paymentErrorContent`) }}
          </p>
          <form
            name="paymentForm"
            id="paymentForm"
            method="POST"
            :action="paymentUrl"
          >
            <input type="hidden" name="MerchantID" :value="merchantId" />
            <input type="hidden" name="Len" :value="paymentParamLen" />
            <input type="hidden" name="Data" :value="paymentParamData" />
            <input type="hidden" name="CustomField1" :value="paymentAmount" />
          </form>
        </div>
      </div>
      <div class="row actions-area">
        <div class="input-group col button-container">
          <button class="pill" @click="subscribe">
            {{ $t(`message.payment.retryPayment`) }}
          </button>
        </div>
        <div class="input-group col button-container">
          <button class="pill" @click="$router.push({ name: 'PersonalHome' })">
            {{ $t(`message.cancel`) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentError",
  data() {
    return {
      merchantId: null,
      paymentUrl: null,
      paymentParamData: null,
      paymentParamLen: null,
      paymentAmount: null,
      currencies: {
        EUR: "€",
        USD: "$",
        AUR: "$",
        GBP: "£",
      },
    };
  },
  methods: {
    subscribe: function () {
      if (
        this.$store.getters["users/isTeacher"] ||
        this.$store.getters["users/isSubscriptionPaid"]
      ) {
        this.$router.push({ name: "PersonalHome" });
        this.$store.dispatch(
          "notifications/addError",
          {
            message: this.$t(`message.notifications.alreadySubscribed`),
          },
          { root: true },
        );
      } else {
        this.$store
          .dispatch("subscriptions/subscribe", {
            email: this.$store.state.users.user.email,
          })
          .then((res) => {
            // Prepare payment form
            this.paymentUrl = res.data.payment_url;
            this.merchantId = res.data.merchant_id;
            this.paymentParamData = res.data.payment_data;
            this.paymentParamLen = res.data.payment_data_len;

            // payment page customization
            const currency =
              this.currencies[res.data.payment_currency] ||
              res.data.payment_currency;
            this.paymentUrl += `?CustomField1=${
              res.data.payment_amount / 100
            }+${currency}`;

            // Submit & go to payment page
            this.$nextTick(() => {
              this.$el.querySelector("#paymentForm").submit();
            });
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 409) {
              this.$router.push({ name: "PersonalHome" });
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(`message.notifications.paymentAlreadyDone`),
                },
                { root: true },
              );
            } else {
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(`message.notifications.paymentError`),
                },
                { root: true },
              );
            }
          })
          .finally(() => {
            this.$store.dispatch(
              "loadings/disableLoadings",
              {},
              { root: true },
            );
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 100px - 126px - 40px);

  .payment-error-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("../assets/subscription/planet-background.webp");
    background-size: cover;
    border-radius: 50px;
    width: 90%;
    padding-left: 6em;
    padding-right: 6em;
    min-height: 400px;
    margin-bottom: 40px;
    text-align: center;

    @media screen and (max-width: 600px) {
      .payment-success-container {
        margin: 10em !important;
      }
    }

    p {
      text-align: justify;
    }

    .payment-error-title {
      margin-bottom: 3rem;
      text-transform: uppercase;
      font-family: "Averia Sans Libre", sans-serif;
      font-weight: 800;
    }

    .actions-area {
      width: 93%;
      display: block;

      @media screen and (min-width: 600px) {
        .button-container {
          float: right;
          max-width: 50%;
        }
      }

      @media screen and (min-width: 600px) {
        .button-container {
          float: right;
          max-width: 50%;
        }
      }

      .button-container {
        justify-content: center;
        padding: 10px;

        .pill {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 130px;
          border: 3px solid $secondaryColor;
          background-color: $secondaryColor;
          color: $whiteColor;
          height: 40px;
          border-radius: 20px;
          font-weight: 800;
          padding: 0.25rem 1rem;
          text-transform: uppercase;
          font-family: "Averia Sans Libre", sans-serif;

          &:hover {
            border: 3px solid $secondaryColor;
            color: $secondaryColor;
            background-color: $backgroundColor;
          }
        }
      }
    }
  }
}
</style>
